import { render, staticRenderFns } from "./ListaAssinaturas.vue?vue&type=template&id=34824f6c&"
import script from "./ListaAssinaturas.vue?vue&type=script&lang=js&"
export * from "./ListaAssinaturas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports